import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

export function useAttachFallbackEmptyB2CServiceHistoryMutation(id: number) {
  const apiClient = useApiClient();
  return useMutation<InferFetchData<typeof attachFallbackEmptyB2CServiceHistory>, ApiError>({
    mutationKey: ['AttachFallbackEmptyB2CServiceHistory'],
    mutationFn: async () => throwOnError(attachFallbackEmptyB2CServiceHistory(apiClient, id!)),
  });
}

function attachFallbackEmptyB2CServiceHistory(apiClient: ApiClient, id: number) {
  return apiClient.PUT('/op/v2/b2c-service-history-request/{id}/confirmation-fallback', {
    params: {
      path: {
        id,
      },
    },
  });
}
useAttachFallbackEmptyB2CServiceHistoryMutation.getKey = (id: number | undefined) => ['AttachFallbackEmptyB2CServiceHistory', id] as const;
